import { apiRequest } from "@/lib/api";

export type NotificationItem = {
  id: string;
  type: string;
  title: string;
  body?: string | null;
  linkPath?: string | null;
  ticketId?: string | null;
  ticketType?: string | null;
  projectId?: string | null;
  projectAlreadyPlanned?: boolean;
  createdAt: string;
  readAt?: string | null;
  dedupCount?: number;
};

export type NotificationsResponse = {
  unreadCount: number;
  items: NotificationItem[];
};

export function fetchNotifications(limit = 20) {
  return apiRequest<NotificationsResponse>(`/notifications?limit=${limit}`, {
    method: "GET",
  });
}

export function markNotificationRead(id: string) {
  return apiRequest<{ success: boolean }>(`/notifications/${id}/read`, {
    method: "POST",
  });
}

export function markAllNotificationsRead() {
  return apiRequest<{ success: boolean; count: number }>("/notifications/mark-all-read", {
    method: "POST",
  });
}
